<template>
  <div id="app">
    <HelloWorld></HelloWorld>
    <router-view />
  </div>
</template>

<script>
import HelloWorld from '@/components/HelloWorld'
export default {
  name: 'App',
  components: {
    HelloWorld
  },
  data() {
    return {
      isLogin: false,
    }
  },
  mounted() {
    this.getInit()
  },
  methods: {
    getInit() {
      let token = JSON.parse(localStorage.getItem('TOKEN'))
      console.log(token)
      if (!token) {
        this.$router.push({ path: '/login' })
      } else {
        this.isLogin = true;
      }
    }
  }
}
</script>

<style>
* {
  margin: 0;
  padding: 0;
}

#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /* text-align: center;
  color: #2c3e50; */
  /* margin-top: 60px; */
}
</style>



// WEBPACK FOOTER //
// src/App.vue